/**
 * Legal Services module navigation — spec-24 W3.2
 * AR/EN labels; AR-first per BRD §11.3.
 */

import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

export const legalServicesNavigation: ModuleNavigation = [
  {
    title: 'Overview',
    items: [
      { path: '/legal-services', label: 'Legal Services Home' },
    ],
  },
  {
    title: 'Matters',
    items: [
      { path: '/legal-services/matters', label: 'All Matters' },
      { path: '/legal-services/kanban/all', label: 'Kanban Pipeline' },
    ],
  },
  {
    title: 'Time & Billing',
    items: [
      { path: '/legal-services/log-hours', label: 'Log Hours' },
      { path: '/billing/invoices', label: 'Invoices' },
    ],
  },
];
